export const GO_NEXT = 'ACTIVATIONMODAL/GO_NEXT';

export const goNext = () => ({
  type: GO_NEXT,
});
